// extracted by mini-css-extract-plugin
var _1 = "di46s";
var _2 = "QdrUx";
var _3 = "jIdm1";
var _4 = "ljSCk";
var _5 = "dPXfr";
var _6 = "DSIdO";
var _7 = "NzIuH";
var _8 = "Flvp1";
var _9 = "UU8iG";
var _a = "ANa_Z";
var _b = "odfcO";
export { _1 as "addOverflowY", _2 as "appContainer", _3 as "appContainerClippedOverflow", _4 as "appContainerHiddenOverflow", _5 as "bleedThrough", _6 as "hideOverflowY", _7 as "main", _8 as "mainContainer", _9 as "monarchAwareBackground", _a as "win32OverlayBackground", _b as "win32OverlayBackgroundMonarch" }
